import { render, staticRenderFns } from "./FundAccount.vue?vue&type=template&id=513cc41b&scoped=true"
import script from "./FundAccount.vue?vue&type=script&lang=js"
export * from "./FundAccount.vue?vue&type=script&lang=js"
import style0 from "./FundAccount.vue?vue&type=style&index=0&id=513cc41b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513cc41b",
  null
  
)

export default component.exports